import { createFileRoute } from "@tanstack/react-router";
import ForFamilies from "@/pages/ForFamilies";
export const Route = createFileRoute("/for-families")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "For Families | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Resources for families supporting a loved one with depression. Learn about TMS, SAINT TMS, and treatment options at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "For Families | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Resources for families supporting a loved one with depression. Learn about TMS, SAINT TMS, and treatment options at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/for-families",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/for-families",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <ForFamilies />;
}
